<template>
    <div class="tw:w-full tw:mt-2 tw:relative tw:border tw:rounded tw:px-4 tw:py-3 tw:bg-[#fffde7]">
        <div class="tw:flex tw:justify-center tw:items-center tw:mb-2 tw:gap-6">
            <img
                src="https://storage.compralaentrada.com/seguro/imagenes/logo_gesa.webp"
                alt="GESA"
                style="max-height: 25px; width: auto;"
            />
            <img
                src="https://storage.compralaentrada.com/seguro/imagenes/logo_ARAG.webp"
                alt="ARAG"
                style="max-height: 30px; width: auto;"
            />
            <img
                src="https://storage.compralaentrada.com/seguro/imagenes/logo_Interlloyd.webp"
                alt="Interlloyd"
                style="max-height: 25px; width: auto;"
            />
        </div>
        <div v-if="selected" data-test="seguro-activo" class="tw:flex tw:flex-wrap tw:md:flex-nowrap tw:items-center tw:justify-between tw:gap-3">
            <div class="tw:flex tw:items-center tw:gap-2 tw:flex-1">
                <div class="tw:flex tw:h-7 tw:w-7 tw:items-center tw:justify-center tw:rounded-full tw:bg-white tw:text-green-600">
                    <span class="tw:font-bold tw:text-sm">✓</span>
                </div>
                <div class="tw:text-left">
                    <div class="tw:text-[11px] tw:font-black tw:uppercase tw:text-green-800 tw:leading-none">
                        {{ $t('seguroEntrada.tituloActivo') }}
                    </div>
                    <div class="tw:text-[10px] tw:text-green-700">
                        {{ $t('seguroEntrada.descripcionActivo') }}
                    </div>
                </div>
            </div>
            <div class="tw:flex tw:items-center tw:gap-2 tw:justify-end">
                <span class="tw:font-bold tw:text-green-800 tw:text-sm">
                    +{{ importe_seguro | formatear_precio }}
                </span>
                <span
                    role="button"
                    class="tw:bg-[#5cb85c] tw:px-4 tw:py-2 tw:text-[12px] tw:font-bold tw:text-white tw:flex tw:items-center tw:gap-1 tw:rounded tw:whitespace-nowrap"
                    :class="{ 'tw:opacity-50 tw:pointer-events-none': loading }"
                    data-test="btn-toggle-seguro-activo"
                    @click="toggleSeguro"
                >
                    <i class="fas fa-check"></i>{{ $t('seguroEntrada.anadido') }}
                    <InfoToolTip :info="$t('seguroEntrada.tooltipEliminar')" />
                </span>
            </div>
        </div>
        <div v-else data-test="seguro-inactivo" class="tw:flex tw:flex-wrap tw:md:flex-nowrap tw:items-center tw:justify-between tw:gap-3">
            <div class="tw:flex tw:items-center tw:gap-2 tw:flex-1">
                <div class="tw:flex tw:h-7 tw:w-7 tw:items-center tw:justify-center tw:rounded-full tw:bg-[#fbc02d] tw:text-white">
                    <i class="fas fa-shield-alt"></i>
                </div>
                <div class="tw:text-left">
                    <div class="tw:text-[11px] tw:font-black tw:uppercase tw:text-gray-800 tw:leading-none">
                        {{ $t('seguroEntrada.tituloInactivo') }}
                    </div>
                    <div class="tw:text-[10px] tw:text-gray-600">
                        {{ $t('seguroEntrada.descripcionInactivo') }}
                    </div>
                </div>
            </div>
            <Button
                class="tw:w-full tw:md:w-auto"
                size=""
                :label="$t('seguroEntrada.botonAnadir', { precio: $n(importe_seguro, 'currency') })"
                :disabled="loading"
                @click="toggleSeguro"
            />
        </div>
        <div class="tw:mt-2 tw:text-[11px] tw:text-gray-700">
            <div>
                {{ $t('seguroEntrada.consultarCondicionesTexto') }}
                <b>
                    <a 
                        href="https://storage.compralaentrada.com/seguro/documentos/Condiciones%20seguro.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        style="text-decoration: underline;"
                    >
                        {{ $t('seguroEntrada.hazClickAqui') }}
                    </a>.
                </b>
            </div>

            <div>
                {{ $t('seguroEntrada.consultarGuiaTexto') }}
                <b>
                    <a 
                        href="https://storage.compralaentrada.com/seguro/documentos/protocolo%20siniestro%20seguro%20de%20anulacion%20de%20entrada.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        style="text-decoration: underline;"
                    >
                        {{ $t('seguroEntrada.hazClickAqui') }}
                    </a>.
                </b>
            </div>
        </div>
    </div>
</template>

<script setup>
    import Button from '@/modules/ui/Button.vue'
    import InfoToolTip from '@/modules/ui/InfoToolTip.vue'

    const emit = defineEmits(['handleSeguro'])

    const props = defineProps({
        selected: {
            type: Boolean,
            default: false
        },
        loading: Boolean,
        importe_seguro: Number
    })

    const toggleSeguro = () => {
        emit('handleSeguro', !props.selected)
    }
</script>
